import * as t from '../actionTypes'

export type ResetFormAction = BaseFSA<undefined>

export const resetForm = (): MrxThunk<ResetFormAction> => async dispatch => {
  dispatch({
    type: t.RESET_FORM
  })
}
